import {ChangeDetectionStrategy, Component, input, OnInit, Signal} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatButton} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {VisSpinnerDirektiv} from "../../../direktiver/button--visSpinner/button--visSpinner";
import {AbstractControl} from "@angular/forms";
import {toObservable, toSignal} from "@angular/core/rxjs-interop";
import {merge, of, switchMap} from "rxjs";
import {map} from "rxjs/operators";

const debug = initDebugger('SubmitButtonKomponent');

/**
 * Submit button som er disablet dersom skjema er ugyldig eller arbeid pågår,
 * og som viser spinner mens arbeid pågår.
 */
@Component({
    selector: 'submit-button',
    templateUrl: 'submit-button.html',
    styleUrl: 'submit-button.scss',
    imports: [
        MatButton,
        TranslateModule,
        VisSpinnerDirektiv
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubmitButtonKomponent implements OnInit {

    skjema = input.required<AbstractControl>();
    arbeidPaagaar = input.required<boolean>();
    spinnerTekst = input('');

    knappDeaktivert: Signal<boolean>;

    constructor() {
        //kan ikke benytte skjema().invalid i html da endringer i denne ikke fører til rendring, konstruerer derfor et signal
        this.knappDeaktivert = toSignal(toObservable(this.skjema)
            .pipe(
              switchMap(skjema => merge(
                of(skjema.invalid), //levere en initiell verdi
                skjema.statusChanges.pipe(map(status => status !== 'VALID')) //lever så ved hver skjema-tilstandsendring
              ))),
          {initialValue: true})
    }

    ngOnInit(): void {

    }

}
